module.exports = __webpack_public_path__ + "static/img/zhfw_05.b5cf0c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Images/zhfw_05.png
// module id = o6P0
// module chunks = 1